define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search",
	"./MassAddMaterialForm"
], function(declare,lang,def,Action,Field,Relationship,ViewRef,locale,csiStore,Names,xml,Query,Search,MassAddMaterialForm) {

	return declare(MassAddMaterialForm, {

	 	FIELD_DEPENDENT_MATERIAL: "DependentMaterial",

		_getDependentMaterialStore: function(viewMaterialCNL) {
			// create store for templates based on selected type
			var matQuery = new Query()
				.Attr("MaterialUsage", xml.OP_NOT_EQUALS, "MaterialUsage:Tool", "Child:ProductType/Child:ProductionConfig")
				.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, viewMaterialCNL);

			// if a BOM section is selected that has a restriction on BOMProductTypes, then apply it
			var selectedSection = this.defView.getFieldValue(this.FIELD_SECTION);
			this.applyBomSectionQuery(selectedSection, matQuery, this.cacheView, false);

			var r = lang.mixin(new Relationship(), {
				m_typeNode: "Material",
				m_query: matQuery
			});

			matQuery.Attr("Hidden", xml.OP_EQUALS, false).Attr("Special", xml.OP_EQUALS, false);

			var	storeOptions = {data: [csiStore.nameObject("")]};
			csiStore.namesOptionsByRelationship(this.getContext(), r, storeOptions);
			storeOptions.action = lang.mixin(new Action(), {
				m_name: locale.resource("SelectDependentMaterial"),
				m_fixedQuery: matQuery,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "AllMaterials",
					m_url: "centric://APPAREL/Views"
				})
			});

			return new Names(storeOptions);
		},

		_resolveView: function() {
			 this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_DEPENDENT_MATERIAL,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_bRequired: true
			}), 0);

			this.lastSearchFieldId = this.FIELD_DEPENDENT_MATERIAL;

			this.inherited(arguments);
		},

		onChangeSection: function(/*csi.def.View*/formView, /*csi.def.Field*/field, /*Any*/value) {
			// summary: when Section field changes, reset the To selection store
			var self = this;
			this.when(this.cacheView.getNodeDeferred(value), function(sectionNode) {
				var fieldTo = formView.getField(self.FIELD_DEPENDENT_MATERIAL);
				if (fieldTo)
					fieldTo.m_control.set("store", self._getDependentMaterialStore());
			});

			this.inherited(arguments);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			// summary: if field is Template, then return store based on product type
			if (field.getControlName() == this.FIELD_DEPENDENT_MATERIAL)
				return this._getDependentMaterialStore(this.viewParent.urlRoot);

			return this.inherited(arguments);
		}
	});
});
